import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider } from "@/store/AuthStore";
import { AppProvider } from "@/store/AppStore";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <AppProvider>
          <BrowserRouter basename={__BASE_PATH__}>
            <AppRoutes />
          </BrowserRouter>
        </AppProvider>
      </AuthProvider>
    </I18nextProvider>
  );
}

export default App;